import React, { useEffect, useState, useContext } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import useModernDialogStyles from "../CrudListPage/useModernDialogStyles";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(1, 0, 2),
  },
  qrCodeContainer: {
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(2),
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const classes = useStyles();
  const dialogClasses = useModernDialogStyles();
  const [qrCode, setQrCode] = useState("");
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;

    const onWhatsappData = (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    };
    socket.on(`company-${companyId}-whatsappSession`, onWhatsappData);

    return () => {
      socket.off(`company-${companyId}-whatsappSession`, onWhatsappData);
    };
  }, [whatsAppId, onClose, user.companyId, socket]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: dialogClasses.paper }}
      aria-labelledby="qr-code-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="qr-code-dialog" className={dialogClasses.title}>
        {i18n.t("qrCode.message")}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {qrCode ? (
          <div className={classes.qrCodeContainer}>
            <QRCode
              value={qrCode}
              size={280}
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
        ) : (
          <Typography variant="body1" className={classes.loadingText}>
            {i18n.t("qrCode.waiting")}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
